<template>
  <div id="message-send-box" :style="focus ? { backgroundColor: '#fff' } : {}">
    <a-row
      type="flex"
      align="middle"
      justify="start"
      :gutter="20"
      class="send-header-bar"
    >
      <a-col>
        <a-popover placement="top" trigger="click">
          <a-row class="emojis" slot="content" type="flex" justify="start">
            <a-col
              v-for="item in emojiName"
              class="emoji"
              :key="item"
              @click="chooseEmoji(item)"
            >
              <img
                :title="item"
                :src="emojiUrl + emojiMap[item]"
                style="width:30px;height:30px"
              />
            </a-col>
          </a-row>
          <icon-font title="发表情" type="smile" />
        </a-popover>
      </a-col>
      <a-col>
        <icon-font title="发图片" type="image" @click="handleSendImageClick" />
      </a-col>
      <a-col>
        <a-icon type="file" title="发送文件" @click="handleSendFileClick" />
      </a-col>
      <a-col>
        <icon-font type="job" title="发送职位" @click="showPostCard" />
      </a-col>
    </a-row>
    <div class="bottom">
      <textarea
        rows="4"
        v-model="messageContent"
        class="text-input"
        @focus="focus = true"
        @blur="focus = false"
        @keydown.enter.exact.prevent="sendTextMessage"
        @keyup.ctrl.enter.prevent.exact="handleLine"
      ></textarea>
      <a-tooltip title="按Enter发送消息，Ctrl+Enter换行" placement="left">
        <div class="btn-send" @click="sendTextMessage">
          <icon-font type="sendair" />
        </div>
      </a-tooltip>
    </div>
    <input
      type="file"
      id="imagePicker"
      ref="imagePicker"
      accept=".jpg, .jpeg, .png, .gif"
      @change="sendImage"
      style="display:none"
    />
    <input
      type="file"
      id="filePicker"
      ref="filePicker"
      @change="sendFile"
      style="display:none"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapState, mapMutations } = createNamespacedHelpers("im");
import { emojiMap, emojiName, emojiUrl } from "@/shared/utils/emojiMap";
export default {
  name: "message-send-box",
  data() {
    return {
      messageContent: "",
      file: "",
      emojiMap: emojiMap,
      emojiName: emojiName,
      emojiUrl: emojiUrl,
      atUserID: "",
      focus: false
    };
  },
  inject: ["boxScrollToBottom", "showPostCard"],
  computed: {
    ...mapState(["currentConversation"]),
    ...mapGetters(["toAccount", "currentConversationType"])
  },
  methods: {
    ...mapMutations(["pushCurrentMessageList", "updatePercent"]),
    handleLine() {
      this.messageContent += "\n";
    },
    chooseEmoji(item) {
      this.messageContent += item;
    },
    handleSendImageClick() {
      this.$refs.imagePicker.click();
    },
    handleSendFileClick() {
      this.$refs.filePicker.click();
    },
    async sendTextMessage() {
      if (
        this.messageContent === "" ||
        this.messageContent.trim().length === 0
      ) {
        this.messageContent = "";
        return;
      }
      const message = this.$tim.createTextMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: { text: this.messageContent }
      });
      this.messageContent = "";
      //手动推消息
      this.pushCurrentMessageList(message);
      this.boxScrollToBottom();
      //发送消息
      try {
        await this.$tim.sendMessage(message);
      } catch (e) {
        this.$message.info(e.message);
      }
    },
    async sendImage() {
      const message = this.$tim.createImageMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: {
          file: document.getElementById("imagePicker") // 或者用event.target
        },
        onProgress: percent => {
          this.$set(message, "progress", percent); // 手动给message 实例加个响应式属性: progress
        }
      });
      this.pushCurrentMessageList(message);
      this.boxScrollToBottom();
      try {
        await this.$tim.sendMessage(message);
        this.$refs.imagePicker.value = null;
      } catch (e) {
        this.$message.info(e.message);
      }
    },
    async sendFile() {
      console.log('file uploading:222')
      const message = this.$tim.createFileMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: {
          file: document.getElementById('filePicker') // 或者用event.target
        },
        onProgress: percent => {
          console.log('file uploading:', percent);
          this.updatePercent(percent);
        }
      })
      this.pushCurrentMessageList(message)
      this.boxScrollToBottom()
      try {
        await this.$tim.sendMessage(message);
        this.$refs.filePicker.value = null;
        this.updatePercent(0);
      } catch (e) {
        this.updatePercent(0);
        this.$message.info(e.message);
      }
    },
  }
};
</script>

<style lang="scss">
#message-send-box {
  padding: 8px 15px 10px;
  .send-header-bar {
    .anticon {
      font-size: 24px;
      cursor: pointer;
      color: #d8d8d8;
      &:hover {
        color: #aaa;
      }
    }
  }
  .bottom {
    position: relative;
    margin-top: 5px;
    textarea {
      font-size: 16px;
      width: 100%;
      -webkit-box-sizing: box-sizing;
      box-sizing: box-sizing;
      border: none;
      outline: none;
      background-color: transparent;
    }
    .btn-send {
      cursor: pointer;
      position: absolute;
      color: #2d8cf0;
      font-size: 30px;
      right: 0;
      bottom: -5px;
      padding: 6px 6px 4px 4px;
      border-radius: 50%;
    }
  }
}
.emojis {
  width: 400px;
  height: 160px;
  overflow-y: scroll;
  .emoji {
    width: 35px;
    height: 35px;
  }
}
</style>
